import App from './App.vue'
import { createApp } from 'vue'
import router from './router'
import Vue from 'vue'
import VueAMap,{initAMapApiLoader} from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css'

 
const app=createApp(App)
// 初始化vue-amap
initAMapApiLoader({
  // 高德的key
  key: 'bd3b44861067b1c52b156d61f16f0c7b',
  // 插件集合
  securityJsCode: 'f4f15c75402000e2804eb2acc90ec4c5',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '2.0'
});

import ECharts from 'vue-echarts'
import 'echarts'
app.component('Echarts',ECharts)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

app.use(router).use(ElementPlus).use(VueAMap)
    .mount('#app')